
























































import { Component, Vue, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";

interface MenuTreeNode {
  id: number;
  icon: string;
  icon_fntaws: string;
  text: string;
  color: string;
  link: string;
  permission: string;
  id_padre: number;
  url_fija: boolean;
  orden: number;
  children?: MenuTreeNode[];
}

@Component({
  name: "MenuTreeItem",
  components: { draggable },
})
export default class MenuTreeItem extends Vue {
  @Prop({ required: true }) item!: MenuTreeNode;

  public expanded: boolean = true;
  public localChildren: MenuTreeNode[] = [];

  public childDragOptions = {
    animation: 200,
    group: "menu",
    disabled: false,
    ghostClass: "ghost",
    handle: ".drag-handle",
  };

  mounted() {
    if (this.item.children) {
      this.localChildren = [...this.item.children];
    }
  }

  get hasChildren(): boolean {
    return !!this.item.children && this.item.children.length > 0;
  }

  onChildDragEnd() {
    // Actualizar el item con los hijos reordenados
    const updatedItem = {
      ...this.item,
      children: this.localChildren,
    };
    this.$emit("update", updatedItem);
  }
}
